export const isDateRangeChildrenElement = (target: Element): boolean => {
  const flatPickrParent = document.querySelector('.fs-unmask')
  const isFlatPickrParent = target === flatPickrParent
  const isChildrenElementOfFlatPickr = flatPickrParent ? flatPickrParent.contains(target) : false

  return isFlatPickrParent || isChildrenElementOfFlatPickr
}
